import { useForm } from 'react-hook-form';
import { Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ForgotPasswordReq } from './api/Application';
import { CenteredPage } from './components/CenteredPage';
import { Api } from "./api/Api";

export function ForgotPasswordPage() {
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm<ForgotPasswordReq>();

    const nav = useNavigate();
    const onSubmit = async ( data: ForgotPasswordReq ) => {
        console.log( "Not implemented!" );
        const res = await Api.forgotPassword( data );
        if( !res.isOk ) {
            return;
        }
    };

    return <CenteredPage sm="10" md="8" lg="6" xl="4" style={{ maxWidth: "33em" }}>
        <Card className="w-100 shadow">
            <Card.Header className="h5 fw-bold">
                Forgot Password
            </Card.Header>
            {/* <Card.Body className="p-4">
                {forgotPasswordMutation.isError && (
                    <Alert variant="danger">
                        {forgotPasswordMutation.error?.message || 'Something went wrong'}
                    </Alert>
                )}
                {forgotPasswordMutation.isSuccess ? (
                    <Alert variant="success">
                        <p>If your email exists in our system, you will receive a password reset link shortly.</p>
                        <p>Please check your email and follow the instructions to reset your password.</p>
                        <div className="text-center mt-3">
                            <Button onClick={() => nav( '/login' )}>
                                Back to Login
                            </Button>
                        </div>
                    </Alert>
                ) : (
                    <Form onSubmit={handleSubmit( onSubmit )}>
                        <Input
                            type="email"
                            icon={<FaUser className="fs-5 text-primary" />}
                            label="Email Address"
                            placeholder="Enter your email"
                            error={errors.emailAddress}
                            {...register( 'emailAddress', {
                                required: 'Email is required',
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: 'Invalid email address'
                                }
                            } )}
                        />
                        <Form.Text className="text-muted mb-3 d-block">
                            We'll send a password reset link to this email address.
                        </Form.Text>

                        <div className="d-flex gap-2">
                            <Button variant="secondary" className="w-100" onClick={() => nav( '/login' )}>
                                Back to Login
                            </Button>
                            <Button
                                className="w-100"
                                type="submit"
                                disabled={forgotPasswordMutation.isPending}
                            >
                                {forgotPasswordMutation.isPending ? 'Sending...' : 'Send Reset Link'}
                            </Button>
                        </div>
                    </Form>
                )}
            </Card.Body> */}
        </Card>
    </CenteredPage>;
}